import { useIntegrationDetailQuery } from 'src/api';

export const useIntegrationDetail = (id: string) => {
  const { data, loading } = useIntegrationDetailQuery({
    variables: { id },
    skip: !id,
  });

  return {
    integration: data?.integration ?? null,
    integrationLoading: loading,
  };
};
